import React  from 'react';
import PropTypes from 'prop-types';

const AdditionalMenuIcon = (props) => {
  const { width, height, theme } = props;
  let color;
  if (theme === 'ink') {
    color = '#FFFFFF';
  }
  else {
    color = '#3A3F4A';
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 17">
      <path fill={color} d="M23 9.5H1c-.552 0-1-.559-1-1.25S.448 7 1 7h22c.552 0 1 .559 1 1.25s-.448 1.25-1 1.25z"/>
      <path fill={color} d="M23 2.5H1c-.552 0-1-.559-1-1.25S.448 0 1 0h22c.552 0 1 .559 1 1.25s-.448 1.25-1 1.25z"/>
      <path fill={color} d="M23 16.5H12c-.552 0-1-.559-1-1.25S11.448 14 12 14h11c.552 0 1 .559 1 1.25s-.448 1.25-1 1.25z"/>
    </svg>
  );
};

AdditionalMenuIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

AdditionalMenuIcon.defaultProps = {
  width: 24,
  height: 17,
  isActive: false,
};

export default AdditionalMenuIcon;
